import { Box, CircularProgress } from '@mui/material'
import { Navigate, Outlet } from 'react-router-dom'
import { useBiAuth } from '../state/BiAuthContext'

/** Exige sessão S2 (cookie). Sem auth → /login (após entrar → sempre Home). */
export function RequireAuth() {
  const { isAuthenticated, bootstrapping } = useBiAuth()

  if (bootstrapping) {
    return (
      <Box
        sx={{
          minHeight: '100vh',
          display: 'grid',
          placeItems: 'center',
          bgcolor: 'background.default',
        }}
      >
        <CircularProgress />
      </Box>
    )
  }

  // Só no dev server (import.meta.env.DEV) e com VITE_BI_PREVIEW_SEM_LOGIN=1 no .env.local:
  // deixa ver telas que não dependem do bridge (ex.: Fábrica de Anúncios, que fala só com o
  // serviço 8104). O bloco some do build de produção.
  if (!isAuthenticated && import.meta.env.DEV && import.meta.env.VITE_BI_PREVIEW_SEM_LOGIN === '1') {
    return <Outlet />
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <Outlet />
}
